module.exports = __webpack_public_path__ + "img/app0401.b2442be2.png";